// The customer's answered fair price on its item row, beside our SP and BP, so
// the operator sees the gap where they set the price. The card below the list
// keeps the full answer and the note.
import { fmt, gapBadge } from './fairPriceGap.js';

export default function TheirPrice({ cents, bp }) {
    if (cents == null) return null;
    const theirs = cents / 100;
    const badge = gapBadge(theirs, bp);
    return (
        <div className="price-field qa-row-their-price" data-testid="qa-row-their-price">
            <span className="price-label">Their price:</span>
            <span className="price-value">£{fmt(theirs)}</span>
            {badge && (
                <span className={`qa-fairprice-gap qa-fairprice-gap--${badge.tone}`}>{badge.label}</span>
            )}
        </div>
    );
}
